import { render } from "./GoogleAuth.vue?vue&type=template&id=5a06087a&scoped=true"
import script from "./GoogleAuth.vue?vue&type=script&lang=js"
export * from "./GoogleAuth.vue?vue&type=script&lang=js"

import "./GoogleAuth.vue?vue&type=style&index=0&id=5a06087a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a06087a"]])

export default __exports__